import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIStatusLabelComponent } from './status-label.component';

@NgModule({
  declarations: [UIStatusLabelComponent],
  imports: [CommonModule],
  exports: [UIStatusLabelComponent],
})
export class UIStatusLabelModule {}
